<template>
    <div class="sidebar">
        <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" background-color="#00d1b2"
            text-color="white" active-text-color="#20a0ff" unique-opened router>
            <template v-for="item in items">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index">
                        <template slot="title">
                            <i :class="item.icon"></i><span slot="title">{{ item.title }}</span>
                        </template>
                        <el-menu-item v-for="(subItem,i) in item.subs" :key="i" :index="subItem.index">
                            {{ subItem.title }}
                        </el-menu-item>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                        <i :class="item.icon"></i><span slot="title">{{ item.title }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
    import bus from '../common/bus';
    export default {
        data() {
            return {
                collapse: false, //默认是否折叠
                items: [
                    {
                        icon: 'fa fa-home',
                        index: '/dashboard',
                        title: '系统首页'
                    },
                    {
                        icon: 'fa fa-users',
                        index: '/user',
                        title: '学员管理'
                    },
                    {
                        icon: 'fa fa-file-text',
                        index: '/record',
                        title: '考试记录'
                    },
                    {
                        icon: 'fa fa-address-card',
                        index: '/certificate',
                        title: '证书管理'
                    },
                    {
                        icon: 'fa fa-cubes',
                        index: '/cpe',
                        title: 'CPE管理'
                    },
                    {
                        icon: 'fa fa-book',
                        index: '/subject',
                        title: '科目管理'
                    },
                    {
                        icon: 'fa el-icon-date',
                        index: '/appointment',
                        title: '预约管理'
                    },
                    {
                        icon: 'fa fa-database',
                        index: '/question',
                        title: '题库管理'
                    },
                    {
                        icon: 'fa fa-bars',
                        index: '/order',
                        title: '订单管理'
                    },
                    {
                        icon: 'fa fa-picture-o',
                        index: '/carousel',
                        title: '轮播图'
                    },
                    {
                        icon: 'fa fa-cog',
                        index: '/systemConfig',
                        title: '系统设置'
                    },
                    {
                        icon: 'el-icon-tickets',
                        index: '/wiki',
                        title: '页面相关',
                        subs: [
                            {
                                index: '/cpeActivity',
                                title: 'CPE近期活动'
                            },
                            {
                                index: '/cpePolicy',
                                title: 'CPE政策'
                            }
                        ]
                    },
                    // {
                    //     icon: 'el-icon-message',
                    //     index: '/tabs',
                    //     title: 'tab选项卡'
                    // },
                    // {
                    //     icon: 'el-icon-date',
                    //     index: '3',
                    //     title: '表单相关',
                    //     subs: [
                    //         {
                    //             index: '/form',
                    //             title: '基本表单'
                    //         },
                    //         {
                    //             index: '/editor',
                    //             title: '富文本编辑器'
                    //         },
                    //         {
                    //             index: '/markdown',
                    //             title: 'markdown编辑器'
                    //         },
                    //         {
                    //             index: '/upload',
                    //             title: '文件上传'
                    //         }
                    //     ]
                    // },
                    // {
                    //     icon: 'el-icon-star-on',
                    //     index: '/charts',
                    //     title: 'schart图表'
                    // },
                    // {
                    //     icon: 'el-icon-rank',
                    //     index: '/drag',
                    //     title: '拖拽列表'
                    // },
                    // {
                    //     icon: 'el-icon-warning',
                    //     index: '/permission',
                    //     title: '权限测试'
                    // },
                    // {
                    //     icon: 'el-icon-error',
                    //     index: '/404',
                    //     title: '404页面'
                    // }
                ]
            }
        },
        computed:{
            onRoutes(){
                // console.log(this.$route.path);
                // return this.$route.path.replace('/','');
                return this.$route.path;
            }
        },
        created(){
            // 通过 Event Bus 进行组件间通信，来折叠侧边栏
            bus.$on('collapse', msg => {
                this.collapse = msg;
            })
        }
    }
</script>

<style scoped>
    .sidebar{
        display: block;
        position: absolute;
        left: 0;
        top: 60px;
        bottom:0;
        overflow-y: scroll;
    }
    .sidebar::-webkit-scrollbar{
        width: 0;
    }
    .sidebar-el-menu:not(.el-menu--collapse){
        width: 180px;
    }
    .sidebar > ul {
        height:100%;
    }

    .el-menu-item [class^=fa] {
        margin-right: 5px;
        width: 24px;
        text-align: center;
        font-size: 18px;
        vertical-align: middle;
    }

</style>
<style>
    /* .el-menu-item, .el-submenu__title{
        height: 36px;
        line-height: 36px;
    } */
    /* .el-submenu__title {
        height: 36px !important;
        line-height: 36px !important;
    } */
</style>
